export function formatPrice(value, language = 'pt-BR') {
  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}
